import { useRegisterAgentContext } from '@backrs_ui/grow-ui/src/agentContext/useRegisterAgentContext';
import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';
import { offeringLabel } from '@backrs_ui/grow-ui/src/pages/CoachingDashboard/namedRefLabel';
import { seatsAgentContext } from '@backrs_ui/grow-ui/src/pages/RostersAdmin/SeatSummary';
import type { AdminRoster } from '@backrs_ui/grow-ui/src/redux/institutionAdmin';

const seatsStrings = appStrings.modules.accountSettings.seats;

export type SeatsWriteDoor = 'mint' | 'revoke';

export const useAgentContext = (
  rosters: readonly AdminRoster[],
  openDoor: SeatsWriteDoor | null,
  openDoorRosterId: number | null,
) => {
  useRegisterAgentContext({ kind: 'tab', title: seatsStrings.tabLabel });

  useRegisterAgentContext(
    openDoor === 'mint'
      ? {
          kind: 'form',
          description:
            'The create-code dialog on the Seats tab. The code is typed by the operator or generated, is six letters or numbers, and is minted for the whole roster rather than a cohort.',
          data: { roster_id: openDoorRosterId, fields: ['code'] },
        }
      : null,
  );

  useRegisterAgentContext(
    openDoor === 'revoke'
      ? {
          kind: 'form',
          description:
            "The revoke-code dialog on the Seats tab, aimed at the roster's shared code.",
          data: { roster_id: openDoorRosterId },
        }
      : null,
  );

  useRegisterAgentContext(
    rosters.length
      ? {
          kind: 'visual',
          label: 'Seats by program',
          display:
            'A card per program, coach and staff offering above the seat allocations, then a Total Filled Seats card last. Each type card reads its seats used, with a Max pill for its cap and a pill for the percentage of its cap filled. A program with no cap shows an Unlimited pill and no percentage pill; the percentage pill shows in red when more are seated than the cap. Staff seats have a card per staff offering, after the program and coach cards.',
          data: seatsAgentContext(rosters),
        }
      : null,
  );

  useRegisterAgentContext(
    rosters.length
      ? {
          kind: 'list',
          description: 'The seat allocations listed on the Seats tab of account settings.',
          data: {
            rosters: rosters.map((roster) => ({
              roster_id: roster.id,
              name: offeringLabel(roster.offering),
              managing_institution_id: roster.managingInstitution.id,
              seats_used: roster.seatsUsed,
              capacity: roster.capacity,
              is_over_cap: roster.isOverCap,
            })),
          },
        }
      : null,
  );
};
